<!-- 新增收货地址 -->
<template>
  <div class="content-box" id="add-address">
    <!-- header start -->
    <van-nav-bar
      title="修改收货地址"
      fixed
      :placeholder="true"
      :z-index="99"
      left-arrow
      @click-left="goBack"
    />
    <!-- header end -->
    <div>
      <van-field v-model="model.Name" label="姓名" placeholder="收货人姓名" />
      <van-field
        v-model="model.Phone"
        type="number"
        label="手机号"
        placeholder="手机号码"
      />
      <van-field
        v-model="model.AreaNames"
        label="所在区域"
        placeholder="请选择所在区域"
        readonly
        is-link
        @click="showArea = true"
      />
      <van-field
        v-model="model.Address"
        label="详细地址"
        placeholder="道路、门牌号、小区、楼"
      />
      <van-cell center title="设为默认地址">
        <template #right-icon>
          <van-switch
            v-model="model.IsDefault"
            size="24"
            active-color="#0684FF"
          />
        </template>
      </van-cell>
    </div>
    <div class="change-btn" @click="updateAddress()" tapmode>
      确认修改
    </div>

    <!-- 省市区弹窗 -->
    <van-popup v-model="showArea" position="bottom" :style="{ height: '45%' }">
      <van-area
        :area-list="areaList"
        @confirm="onAreaConfirm"
        @cancel="showArea = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Area } from "vant";
import { areaList } from "@vant/area-data";
export default {
  data() {
    return {
      showArea: false,
      address: "选择省、市、区",
      areaList,
      areaRegion: "",
      inputInfo: {
        isDefault: false,
      },
      isGetAddress: false, //获取的地址
      model: this.$route.params.model,
    };
  },
  components: {
    [Area.name]: Area,
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onAreaConfirm(val) {
      this.showArea = false;
      // this.areaRegion = val;
      var addrInfo = val[0].name + "-" + val[1].name + "-" + val[2].name;
      // this.areaRegion = addrInfo;
      this.model.AreaNames = addrInfo;
    },
    updateAddress() {
      if (this.model.Name == "") {
        this.$toast("姓名不能为空！");
        return false;
      }
      if (this.model.Phone == "") {
        this.$toast("手机号不能为空！");
        return false;
      }
      var myreg = /^[1][0-9]{10}$/;
      if (!myreg.test(this.model.Phone)) {
        this.$toast("请输入正常的手机号!");
        return false;
      }
      if (this.model.AreaNames == "") {
        this.$toast("请选择所在区域!");
        return false;
      }
      if (this.model.Address == "") {
        this.$toast("详细地址不能为空！");
        return false;
      }
      var _this = this;
      // console.log(this.model);
      this.$store
        .dispatch({
          type: "addAndUpdateAddress",
          serialNumber: this.model.SerialNumber,
          name: this.model.Name,
          phone: this.model.Phone,
          areaNames: this.model.AreaNames,
          address: this.model.Address,
          isDefault: this.model.IsDefault
        })
        .then((res) => {
          // console.log(res);
          if (res.Result.IsSuccess) {
            _this.$toast(res.Result.Message);
            _this.$router.go(-1);
          } else {
            this.$toast(res.Result.Message);
          }
        });
    },
  },
  activated(){
    
  }
};
</script>
<style lang="scss" scoped></style>
